module.exports = __webpack_public_path__ + "img/hygh.b70392e2.webp";